export const unitTypes = [
  {
    path: '/unit-types',
    name: 'unitTypes',
    component: () => import('./unitTypes.vue'),
    meta: {
      rule: 'UNIT_TYPES',
      authRequired: true,
      title: 'general.unitTypes',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.unitTypes',
          disabled: true,
          href: '#/unit-types',
        }
      ]
    }
  },
  {
    path: '/unit-types/add',
    name: 'newType',
    component: () => import('./Form.vue'),
    meta: {
      rule: 'UNIT_TYPE_CREATE',
      authRequired: true,
      title: 'general.company',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.unitTypes',
          disabled: false,
          href: '#/unit-types',
        },
        {
          text: 'unitTypes.add',
          disabled: true,
          href: '#/unit-types/add',
        }
      ]
    }
  },
  {
    path: '/unit-types/edit/:id',
    name: 'editType',
    component: () => import('./Form.vue'),
    meta: {
      rule: 'UNIT_TYPE_UPDATE',
      authRequired: true,
      title: 'general.company',
      breadcrumb: [
        {
          text: 'general.home',
          disabled: false,
          href: '#/',
        },
        {
          text: 'general.unitTypes',
          disabled: false,
          href: '#/unit-types',
        },
        {
          text: 'unitTypes.edit',
          disabled: true,
          href: '#/unit-types',
        }
      ]
    }
  }
]